import React from 'react';
import PlatformIcon from './PlatformIcon';

function PlatformSectionTitle({ icon, children }) {
  return (
    <div className="platform-row platform-section-title">
      <PlatformIcon name={icon} size={16} color="var(--primary)" />
      <span>{children}</span>
    </div>
  );
}

export default PlatformSectionTitle;
